module.exports = __webpack_public_path__ + "img/bag-tag.dbd588a3.png";